const mainSearchForm = {
  flights: "Vols", // translated
  tours: "Visites", // translated
  hotel: "Hôtel", // translated
  hotels: "Hôtels", // translated
  services: "Prestations de service", // translated
  search: "CHERCHER", // translated
  destination: "Destination", // translated
  includedServices: "Services inclus", // translated
  packageDuration: "Durée du forfait", // translated
  checkInOut: "Arrivée/Départ", // translated
  guests: "Invités", // translated
  adults: "Adultes", // translated
  children: "Enfants", // translated
  child: "Enfant", // translated
  age: "Âge", // translated
  yearsOld: "Ans", // translated
  rooms: "Pièces", // translated
  close: "proche", // translated
  searchType: "Type de recherche", // translated
  accommodation: "Logement", // translated
  transfers: "Transferts", // translated
  toursExperiences: "Visites/Expériences", // translated
  nights: "Nuits", // translated
  days: "Jours", // translated
  packageType: "Type d'emballage", // translated
  tourType: "Type de visite", // translated
  packages: "Paquets", // translated
  cars: "Voitures", // translated
  cruises: "Croisières", // translated
  roundTrip: "Aller-retour", // translated
  infantsInSeat: "Bébés assis sur le siège", // translated
  thingsToDo: "Choses à faire", // translated
  passengers: "Passagers", // translated
  departureReturn: "Dates de départ et de retour", // translated
  origin: "Origine", // translated
  airport: "Aéroport", // translated
  partying: "Faire la fête", // translated
  dream_packages: "Forfaits de rêve", // translated
  isRoundTrip: "C'est un aller-retour", // translated
  infantsOnLap: "Bébés sur les genoux", // translated
};


export default mainSearchForm;
